export const REVENUE_TYPES = [
  { value: 'compensation', label: 'Compensación' },
  { value: 'rebate', label: 'Rebate' },
  { value: 'revenue_adjustment', label: 'Ajuste de Ingreso' },
  { value: 'commission_adjustment', label: 'Ajuste de Comisión' },
  { value: 'tax_adjustment', label: 'Ajuste de Impuesto' },
  { value: 'other_costs_adjustment', label: 'Ajuste de Otros Costos' },
  { value: 'freight_adjustment', label: 'Ajuste de Flete' },
  { value: 'other', label: 'Otro' },
  { value: 'claim_compensation', label: 'Comparativa Cliente' },
  { value: 'manual_injection', label: 'Inyección Manual' },
];

export const REVENUE_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  REVENUE_TYPES.map((t) => [t.value, t.label])
);
